"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationAttribute = void 0;
var React = require("react");
/**
 * e.g. <link rel="next" href="https://www.expedia.com/All-Boston-Hotels.d178239.Travel-Guide-City-All-Hotels">
 */
var PaginationAttribute = /** @class */function () {
  function PaginationAttribute(rel, href) {
    this.rel = rel;
    this.href = href;
  }
  PaginationAttribute.prototype.renderMetaElement = function () {
    return React.createElement("link", {
      rel: this.rel,
      href: this.href
    });
  };
  return PaginationAttribute;
}();
exports.PaginationAttribute = PaginationAttribute;